import { useDispatch, useSelector } from 'react-redux';
import { styled, SwipeableDrawer, useMediaQuery } from '@mui/material';

import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import NavbarStyle1Content from './NavbarStyle1Content';

interface NavbarProps {
	open: boolean;
	position: 'left' | 'right';
}

const navbarWidth = 280;

const StyledNavBar = styled('div')<NavbarProps>(({ theme, open, position }) => ({
	minWidth: navbarWidth,
	width: navbarWidth,
	maxWidth: navbarWidth,
	...(!open && {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.leavingScreen
		}),
		...(position === 'left' && {
			marginLeft: `-${navbarWidth}px`
		}),
		...(position === 'right' && {
			marginRight: `-${navbarWidth}px`
		})
	}),
	...(open && {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen
		})
	})
}));

const StyledNavBarMobile = styled(SwipeableDrawer)(({ theme }) => ({
	'& .MuiDrawer-paper': {
		minWidth: navbarWidth,
		width: navbarWidth,
		maxWidth: navbarWidth
	}
}));

function NavbarStyle1() {
	const dispatch = useDispatch();
	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);
	const navbar = useSelector(({ fuse }: any) => fuse.navbar);
	const isXlUp = useMediaQuery(theme => theme.breakpoints.up('xl'));

	return isXlUp ? (
		<StyledNavBar
			className="sticky top-0 z-20 h-screen flex-auto shrink-0 flex-col overflow-hidden shadow-5"
			open={navbar.open}
			position={config.navbar.position}
		>
			<NavbarStyle1Content />
		</StyledNavBar>
	) : (
		<StyledNavBarMobile
			classes={{
				paper: 'flex-col flex-auto h-full'
			}}
			anchor={config.navbar.position}
			variant="temporary"
			open={navbar.mobileOpen}
			onClose={() => dispatch(navbarCloseMobile())}
			onOpen={() => {}}
			disableSwipeToOpen
			ModalProps={{
				keepMounted: true // Better open performance on mobile.
			}}
		>
			<NavbarStyle1Content />
		</StyledNavBarMobile>
	);
}

export default NavbarStyle1;
